import queryString from 'query-string';
import conf from '../config';

const initialState = {
  requests: {},
};

const ADD_REQUEST = 'ADD_REQUEST';
const SET_REQUESTS = 'SET_REQUEST';

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_REQUEST:
      const newRequests = Object.assign({}, state.reqeusts, {
        [action.payload._id]: action.payload,
      });
      return { ...state, requests: newRequests };
    case SET_REQUESTS:
      return { ...state, requests: action.payload };
    default:
      return state;
  }
};

const addRequest = request => ({ type: ADD_REQUEST, payload: request });

const setRequests = requests => ({ type: SET_REQUESTS, payload: requests });

export const getRequests = state => state.requests.requests;

export function createRequest(data) {
  return async dispatch => {
    const result = await fetch(`${conf.apiRoot}/api/requests`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(data),
    }).then(res => {
      if (res.status === 200) return res.json();
      return null;
    });
    if (result) {
      dispatch(addRequest(result.model));
      return result.model._id;
    }
  };
}

export function fetchRequests(query) {
  return async dispatch => {
    const requests = await fetch(
      `${conf.apiRoot}/api/requests?${queryString.stringify(query)}`,
      {
        credentials: 'include',
      }
    ).then(res => {
      if (res.status === 200) return res.json();
      return [];
    });
    dispatch(setRequests(requests));
  };
}

export const getRequest = id => async (dispatch, getState) => {
  const state = getState();
  const requests = getRequests(state);
  if (requests[id]) return requests[id];
  const request = await fetch(`${conf.apiRoot}/api/requests/${id}`, {
    credentials: 'include',
  }).then(res => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (request) dispatch(addRequest(request));
  return request;
};

export const updateRequest = (id, update) => async dispatch => {
  const result = await fetch(`${conf.apiRoot}/api/requests/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(update),
  }).then(res => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (result && result.status === 'ok') {
    dispatch(addRequest(result.model));
  }
};



// WEBPACK FOOTER //
// ./src/modules/requests.js